<app-loader *ngIf="createBrigadeLoading"></app-loader>
<div class="modal__header">
  <span class="title">Формирование новой бригады</span>
  <div class="modal-close color-gray-dark" (click)="activeModal.dismiss()" id="appCloseXCreateBrigade"></div>
</div>
<div class="modal__body">
  <span *ngIf="currentBrigade?.brigade_head.u_id === user.u_id">Бригадир</span>
  <span *ngIf="currentBrigade?.brigade_head.u_id !== user.u_id">Основной сотрудник</span>
  {{ user.employee.full_name }} будет перенесен в новую бригаду.

  <div class="mt-16" *ngIf="createType === 1">
    <app-field>
      <label>Название бригады</label>
      <input type="text" class="input-text" [(ngModel)]="brigadeName" id="brigadeName" />
    </app-field>
  </div>

  <div class="mt-16" *ngIf="createType === 2">
    <app-field>
      <label>Новый бригадир в текущей бригаде</label>
      <app-combobox
        [items]="brigadeHeadListInBrigade"
        (callback)="onChangeSelectedNewBrigadeHead($event)"
        [textKey]="'full_name'"
        [defaultText]="'Выберите бригадира'"
        [initBy]="brigadeHeadNewSelected"
        [name]="'newBrigadeHead'"
      ></app-combobox>
    </app-field>
  </div>

  <div class="mt-16" *ngIf="errorMessage">
    <app-message [type]="'error'">
      <div message-content>
        {{ errorMessage }}
      </div>
    </app-message>
  </div>
</div>
<div class="modal__footer">
  <div class="modal__footer-action">
    <button class="button" type="button" [disabled]="checkDisabled()" (click)="onCreateBrigade()" id="appCreateBrigade">Перенести</button>
  </div>
  <div class="modal__footer-action">
    <a class="link link--dotted-blue-dark" (click)="activeModal.dismiss()" id="appCloseCreateBrigade"> Отмена </a>
  </div>
</div>
